const translations = {
  fr: {
    // Nav
    dashboard: 'Tableau de bord',
    coach: 'Coach IA',
    simulation: 'Simulation',
    analysis: 'Analyse',
    progress: 'Progression',
    routine: 'Routine',
    history: 'Historique',
    settings: 'Param\u00e8tres',
    logout: 'D\u00e9connexion',
    
    // Auth
    login: 'Connexion',
    register: 'Inscription',
    email: 'Email',
    password: 'Mot de passe',
    name: 'Nom',
    confirmPassword: 'Confirmer le mot de passe',
    noAccount: "Pas de compte ?",
    hasAccount: 'D\u00e9j\u00e0 un compte ?',
    loginTitle: 'Bienvenue',
    loginSubtitle: 'Votre coach IA personnel',
    registerTitle: 'Cr\u00e9er un compte',
    
    // Onboarding
    onboardingTitle: 'Cr\u00e9ons votre profil',
    onboardingSubtitle: 'Ces informations permettent \u00e0 l\'IA de personnaliser vos recommandations',
    stepIdentity: 'Identit\u00e9',
    stepMorphology: 'Morphologie',
    stepGoals: 'Objectifs',
    stepStyle: 'Style',
    stepConfirm: 'Confirmer',
    next: 'Suivant',
    back: 'Retour',
    startAnalysis: 'Lancer l\'analyse',
    age: '\u00c2ge',
    height: 'Taille (cm)',
    weight: 'Poids (kg)',
    morphology: 'Morphologie',
    faceShape: 'Forme du visage',
    skinType: 'Type de peau',
    skinTone: 'Carnation',
    currentStyle: 'Style actuel',
    budget: 'Budget mensuel',
    goals: 'Objectifs',
    constraints: 'Contraintes professionnelles',
    groomingHabits: 'Habitudes grooming',
    fitnessLevel: 'Niveau fitness',
    
    // Morphology options
    ectomorph: 'Ectomorphe',
    mesomorph: 'M\u00e9somorphe',
    endomorph: 'Endomorphe',
    oval: 'Ovale',
    round: 'Rond',
    square: 'Carr\u00e9',
    heart: 'Coeur',
    oblong: 'Oblong',
    normal: 'Normale',
    dry: 'S\u00e8che',
    oily: 'Grasse',
    combination: 'Mixte',
    sensitive: 'Sensible',
    very_fair: 'Tr\u00e8s claire',
    fair: 'Claire',
    medium: 'M\u00e9dium',
    olive: 'Olive',
    dark: 'Fonc\u00e9e',
    very_dark: 'Tr\u00e8s fonc\u00e9e',
    
    // Budget
    low: 'Faible (<100\u20ac/mois)',
    med: 'Moyen (100-300\u20ac/mois)',
    high: '\u00c9lev\u00e9 (300-500\u20ac/mois)',
    premium: 'Premium (500\u20ac+/mois)',
    
    // Goals
    dating: 'Dating',
    career: 'Carri\u00e8re',
    confidence: 'Confiance',
    social_media: 'R\u00e9seaux sociaux',
    health: 'Sant\u00e9',
    style_goal: 'Style personnel',
    
    // Fitness
    sedentary: 'S\u00e9dentaire',
    light: 'L\u00e9ger',
    moderate: 'Mod\u00e9r\u00e9',
    active: 'Actif',
    athlete: 'Athl\u00e8te',
    
    // Dashboard
    overallScore: 'Score global',
    sessions: 'Sessions',
    analyses: 'Analyses',
    reminders: 'Rappels actifs',
    quickActions: 'Actions rapides',
    startChat: 'D\u00e9marrer une session',
    uploadPhoto: 'Analyser une photo',
    generateRoutine: 'G\u00e9n\u00e9rer routine',
    fullAnalysis: 'Analyse compl\u00e8te',
    recentSessions: 'Sessions r\u00e9centes',
    noSessions: 'Aucune session pour le moment',
    
    // Chat
    typeMessage: '\u00c9crivez votre message...',
    send: 'Envoyer',
    attachPhoto: 'Joindre une photo',
    analyzing: 'Analyse en cours...',
    thinking: 'R\u00e9flexion...',
    newSession: 'Nouvelle session',
    
    // Analysis
    photoAnalysis: 'Analyse photo',
    textAnalysis: 'Analyse textuelle',
    uploadInstructions: 'Uploadez une photo (face, profil, ou corps entier) pour une analyse compl\u00e8te',
    analyzeNow: 'Analyser maintenant',
    
    // Progress
    addEntry: 'Ajouter une entr\u00e9e',
    metricType: 'Type de m\u00e9trique',
    value: 'Valeur',
    notes: 'Notes',
    overall_score: 'Score global',
    weight_metric: 'Poids',
    fitness: 'Fitness',
    grooming: 'Grooming',
    style_metric: 'Style',
    confidence_metric: 'Confiance',
    noProgress: 'Aucune donn\u00e9e de progression',
    
    // Routine
    generateNew: 'G\u00e9n\u00e9rer une nouvelle routine',
    downloadPdf: 'T\u00e9l\u00e9charger PDF',
    noRoutine: 'Aucune routine g\u00e9n\u00e9r\u00e9e',
    generating: 'G\u00e9n\u00e9ration en cours...',
    
    // Settings
    language: 'Langue',
    french: 'Fran\u00e7ais',
    english: 'Anglais',
    notificationSettings: 'Param\u00e8tres notifications',
    training: 'Entra\u00eenement',
    grooming_reminder: 'Grooming',
    style_reminder: 'Style',
    posture: 'Posture',
    checkin: 'Check-in',
    daily: 'Quotidien',
    weekly: 'Hebdomadaire',
    biweekly: 'Bi-hebdomadaire',
    save: 'Sauvegarder',
    saved: 'Sauvegard\u00e9 !',
    profile: 'Profil',
    editProfile: 'Modifier le profil',

    // Reminders (email)
    reminderEmailTo: 'Les rappels sont envoy\u00e9s par email \u00e0',
    reminderGuestNotice: 'Mode invit\u00e9 : cr\u00e9ez un compte avec votre vraie adresse email pour recevoir les rappels par email.',
    reminderNotConfigured: 'L\'envoi d\'emails n\'est pas encore configur\u00e9 sur le serveur.',
    reminderFrequencyHelp: 'Quotidien = tous les jours \u00b7 Hebdomadaire = lundi \u00b7 Bi-hebdomadaire = lundi et jeudi. Heure locale',
    reminderTestSend: 'Envoyer un rappel test',
    reminderTestSending: 'Envoi en cours...',
    reminderTestSent: 'Rappel test envoy\u00e9 ! V\u00e9rifiez votre bo\u00eete mail.',
    reminderTestError: 'Impossible d\'envoyer le rappel test',
    reminderLastSent: 'Derniers envois',
    reminderStatusSent: 'Envoy\u00e9',
    reminderStatusFailed: '\u00c9chec',
    reminderAiNote: 'Chaque rappel contient un conseil personnalis\u00e9 g\u00e9n\u00e9r\u00e9 par votre coach IA.',

    // Support / Contact
    supportTitle: 'Aide & Support',
    supportIntro: 'Une question, un bug ou une suggestion ? \u00c9crivez-nous directement ici, notre \u00e9quipe vous r\u00e9pond sous 24 \u00e0 48h.',
    contactSubject: 'Sujet',
    contactSubjectPlaceholder: 'Ex : Probl\u00e8me avec la simulation',
    contactMessage: 'Message',
    contactMessagePlaceholder: 'D\u00e9crivez votre demande (10 caract\u00e8res minimum)...',
    contactEmail: 'Votre email pour la r\u00e9ponse',
    contactEmailPlaceholder: 'vous@exemple.com',
    contactSend: 'Envoyer le message',
    contactSending: 'Envoi...',
    contactSent: 'Message envoy\u00e9 ! R\u00e9f\u00e9rence',
    contactError: 'Impossible d\'envoyer le message',
    contactTooMany: 'Trop de messages envoy\u00e9s, r\u00e9essayez dans une heure.',
    contactOrEmail: 'ou par email :',

    // Photo consent
    consentTitle: 'Utilisation de vos photos',
    consentIntro: 'Avant votre premi\u00e8re analyse photo, voici comment PrimeFace utilise vos images :',
    consentPoint1: 'Votre photo est analys\u00e9e par une IA (OpenAI) pour produire des recommandations esth\u00e9tiques.',
    consentPoint2: 'Pour les simulations, une version compress\u00e9e Avant / Apr\u00e8s est conserv\u00e9e dans votre historique pendant {days} jours, puis supprim\u00e9e automatiquement.',
    consentPoint3: 'Vous pouvez supprimer chaque simulation \u00e0 tout moment depuis l\'historique.',
    consentPoint4: 'Vos photos ne sont jamais partag\u00e9es avec des tiers ni utilis\u00e9es \u00e0 des fins publicitaires.',
    consentCheckbox: 'J\'ai compris et j\'accepte l\'utilisation de mes photos dans ces conditions.',
    consentAccept: 'Continuer',
    consentCancel: 'Annuler',
    consentSaved: 'Merci, votre choix est enregistr\u00e9.',
    consentError: 'Impossible d\'enregistrer votre consentement',
    consentRequired: 'Vous devez accepter l\'utilisation de vos photos pour continuer.',

    // Compare simulations
    compare: 'Comparer',
    compareMode: 'Mode comparaison',
    compareHint: 'S\u00e9lectionnez deux simulations de dates diff\u00e9rentes',
    compareNeedTwo: 'Il faut au moins deux simulations pour comparer',
    compareSelected: 's\u00e9lectionn\u00e9e(s)',
    compareTitle: 'Comparaison de progression',
    compareSubtitle: 'Votre \u00e9volution r\u00e9elle entre deux dates',
    compareRealPhotos: 'Photos r\u00e9elles',
    compareSimulations: 'Simulations IA',
    compareDownload: 'T\u00e9l\u00e9charger la comparaison',
    compareBack: 'Retour aux simulations',
    compareLoadError: 'Impossible de charger les deux simulations',
    compareDaysApart: 'jours d\'\u00e9cart',
    compareNeedTwoTitle: 'Comparez votre progression dans le temps',
    compareNeedTwoBody: 'R\u00e9alisez au moins deux simulations \u00e0 des dates diff\u00e9rentes : vous pourrez ensuite les placer c\u00f4te \u00e0 c\u00f4te pour visualiser votre \u00e9volution r\u00e9elle.',
    compareNeedOneMore: 'Encore une simulation et la comparaison sera disponible.',
    newSimulation: 'Nouvelle simulation',
    compareShare: 'Partager la comparaison',
    keepLearning: 'Pour continuer',
    keepLearningNote: 'Articles du guide PrimeFace li\u00e9s \u00e0 cette r\u00e9ponse',
    readThisWeek: '\u00c0 lire cette semaine',
    readingReasonMetric: 'Choisi d\u2019apr\u00e8s votre indicateur le plus bas : {metric} ({value}/100)',
    readingReasonWeekly: 'S\u00e9lection de la semaine, en attendant vos premi\u00e8res m\u00e9triques',
    allTipsLink: 'Tous les conseils',
    compareShareTitle: 'Ma progression PrimeFace',
    compareShareText: 'Voici ma progression entre deux dates, suivie avec PrimeFace.',
    retentionNote: 'Les simulations sont conserv\u00e9es {days} jours puis supprim\u00e9es automatiquement.',

    // Admin reply
    reply: 'R\u00e9pondre',
    replyPlaceholder: 'Votre r\u00e9ponse sera envoy\u00e9e par email au demandeur...',
    replySend: 'Envoyer la r\u00e9ponse',
    replySending: 'Envoi...',
    replySent: 'R\u00e9ponse envoy\u00e9e par email',
    replyError: 'Impossible d\'envoyer la r\u00e9ponse',
    replyNoRecipient: 'Aucune adresse email pour r\u00e9pondre \u00e0 ce message',
    replyMarkHandled: 'Marquer comme trait\u00e9 apr\u00e8s envoi',
    replies: 'R\u00e9ponses envoy\u00e9es',
    sentTo: 'envoy\u00e9e \u00e0',

    // Simulation share
    shareImage: 'Partager',
    sharingImage: 'Pr\u00e9paration...',
    shareUnavailable: 'Partage direct indisponible sur cet appareil, l\'image a \u00e9t\u00e9 t\u00e9l\u00e9charg\u00e9e.',
    shareTitle: 'Ma simulation Avant / Apr\u00e8s PrimeFace',
    shareText: 'Voici ma simulation Avant / Apr\u00e8s g\u00e9n\u00e9r\u00e9e par PrimeFace.',
    shareError: 'Impossible de partager l\'image',

    // Simulation history
    simulations: 'Simulations',
    conversations: 'Conversations',
    noSimulations: 'Aucune simulation sauvegard\u00e9e pour le moment',
    savedSimulation: 'Simulation sauvegard\u00e9e',
    openSimulation: 'Ouvrir',
    simulationNotFound: 'Simulation introuvable',
    loadingSimulation: 'Chargement de la simulation...',
    savedOn: 'Enregistr\u00e9e le',

    // Jobs / background
    jobTimeout: 'L\'op\u00e9ration prend trop de temps, r\u00e9essayez.',
    analysisInProgress: 'Analyse compl\u00e8te en cours, cela peut prendre une minute...',
    routineInProgress: 'G\u00e9n\u00e9ration de votre routine en arri\u00e8re-plan...',

    // Admin inbox
    adminInbox: 'Bo\u00eete support',
    adminInboxSubtitle: 'Messages re\u00e7us via le formulaire de contact',
    statusNew: 'Nouveaux',
    statusHandled: 'Trait\u00e9s',
    statusAll: 'Tous',
    badgeNew: 'Nouveau',
    badgeHandled: 'Trait\u00e9',
    markHandled: 'Marquer trait\u00e9',
    reopen: 'Rouvrir',
    replyByEmail: 'R\u00e9pondre par email',
    noContactEmail: 'Pas d\'email de contact',
    noMessages: 'Aucun message',
    guestUser: 'Invit\u00e9',
    handledBy: 'Trait\u00e9 par',
    searchMessages: 'Rechercher (sujet, email, r\u00e9f\u00e9rence)...',
    adminOnly: 'Acc\u00e8s r\u00e9serv\u00e9 aux administrateurs',
    adminNote: 'Note interne',
    adminNotePlaceholder: 'Ajouter une note interne (optionnel)',
    saveNote: 'Enregistrer la note',
    downloadImage: 'T\u00e9l\u00e9charger l\'image Avant / Apr\u00e8s',
    downloadingImage: 'Pr\u00e9paration de l\'image...',
    imageDownloaded: 'Image t\u00e9l\u00e9charg\u00e9e !',
    imageDownloadError: 'Impossible de g\u00e9n\u00e9rer l\'image',
    
    // History  
    chatHistory: 'Historique des sessions',
    searchSessions: 'Rechercher...',
    deleteSession: 'Supprimer',
    openSession: 'Ouvrir',
    noHistory: 'Aucun historique',
  },
  en: {
    // Nav
    dashboard: 'Dashboard',
    coach: 'AI Coach',
    simulation: 'Simulation',
    analysis: 'Analysis',
    progress: 'Progress',
    routine: 'Routine',
    history: 'History',
    settings: 'Settings',
    logout: 'Logout',
    
    // Auth
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    confirmPassword: 'Confirm password',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    loginTitle: 'Welcome Back',
    loginSubtitle: 'Your personal AI coach',
    registerTitle: 'Create Account',
    
    // Onboarding
    onboardingTitle: "Let's create your profile",
    onboardingSubtitle: 'This information helps the AI personalize your recommendations',
    stepIdentity: 'Identity',
    stepMorphology: 'Morphology',
    stepGoals: 'Goals',
    stepStyle: 'Style',
    stepConfirm: 'Confirm',
    next: 'Next',
    back: 'Back',
    startAnalysis: 'Start Analysis',
    age: 'Age',
    height: 'Height (cm)',
    weight: 'Weight (kg)',
    morphology: 'Body Type',
    faceShape: 'Face Shape',
    skinType: 'Skin Type',
    skinTone: 'Skin Tone',
    currentStyle: 'Current Style',
    budget: 'Monthly Budget',
    goals: 'Goals',
    constraints: 'Professional Constraints',
    groomingHabits: 'Grooming Habits',
    fitnessLevel: 'Fitness Level',
    
    // Morphology options
    ectomorph: 'Ectomorph',
    mesomorph: 'Mesomorph',
    endomorph: 'Endomorph',
    oval: 'Oval',
    round: 'Round',
    square: 'Square',
    heart: 'Heart',
    oblong: 'Oblong',
    normal: 'Normal',
    dry: 'Dry',
    oily: 'Oily',
    combination: 'Combination',
    sensitive: 'Sensitive',
    very_fair: 'Very Fair',
    fair: 'Fair',
    medium: 'Medium',
    olive: 'Olive',
    dark: 'Dark',
    very_dark: 'Very Dark',
    
    // Budget
    low: 'Low (<$100/mo)',
    med: 'Medium ($100-300/mo)',
    high: 'High ($300-500/mo)',
    premium: 'Premium ($500+/mo)',
    
    // Goals
    dating: 'Dating',
    career: 'Career',
    confidence: 'Confidence',
    social_media: 'Social Media',
    health: 'Health',
    style_goal: 'Personal Style',
    
    // Fitness
    sedentary: 'Sedentary',
    light: 'Light',
    moderate: 'Moderate',
    active: 'Active',
    athlete: 'Athlete',
    
    // Dashboard
    overallScore: 'Overall Score',
    sessions: 'Sessions',
    analyses: 'Analyses',
    reminders: 'Active Reminders',
    quickActions: 'Quick Actions',
    startChat: 'Start a Session',
    uploadPhoto: 'Analyze Photo',
    generateRoutine: 'Generate Routine',
    fullAnalysis: 'Full Analysis',
    recentSessions: 'Recent Sessions',
    noSessions: 'No sessions yet',
    
    // Chat
    typeMessage: 'Type your message...',
    send: 'Send',
    attachPhoto: 'Attach Photo',
    analyzing: 'Analyzing...',
    thinking: 'Thinking...',
    newSession: 'New Session',
    
    // Analysis
    photoAnalysis: 'Photo Analysis',
    textAnalysis: 'Text Analysis',
    uploadInstructions: 'Upload a photo (face, profile, or full body) for a complete analysis',
    analyzeNow: 'Analyze Now',
    
    // Progress
    addEntry: 'Add Entry',
    metricType: 'Metric Type',
    value: 'Value',
    notes: 'Notes',
    overall_score: 'Overall Score',
    weight_metric: 'Weight',
    fitness: 'Fitness',
    grooming: 'Grooming',
    style_metric: 'Style',
    confidence_metric: 'Confidence',
    noProgress: 'No progress data yet',
    
    // Routine
    generateNew: 'Generate New Routine',
    downloadPdf: 'Download PDF',
    noRoutine: 'No routine generated yet',
    generating: 'Generating...',
    
    // Settings
    language: 'Language',
    french: 'French',
    english: 'English',
    notificationSettings: 'Notification Settings',
    training: 'Training',
    grooming_reminder: 'Grooming',
    style_reminder: 'Style',
    posture: 'Posture',
    checkin: 'Check-in',
    daily: 'Daily',
    weekly: 'Weekly',
    biweekly: 'Bi-weekly',
    save: 'Save',
    saved: 'Saved!',
    profile: 'Profile',
    editProfile: 'Edit Profile',

    // Reminders (email)
    reminderEmailTo: 'Reminders are emailed to',
    reminderGuestNotice: 'Guest mode: create an account with your real email address to receive reminders by email.',
    reminderNotConfigured: 'Email sending is not configured on the server yet.',
    reminderFrequencyHelp: 'Daily = every day \u00b7 Weekly = Monday \u00b7 Bi-weekly = Monday and Thursday. Local time',
    reminderTestSend: 'Send a test reminder',
    reminderTestSending: 'Sending...',
    reminderTestSent: 'Test reminder sent! Check your inbox.',
    reminderTestError: 'Could not send the test reminder',
    reminderLastSent: 'Recent deliveries',
    reminderStatusSent: 'Sent',
    reminderStatusFailed: 'Failed',
    reminderAiNote: 'Each reminder includes a personalised tip generated by your AI coach.',

    // Support / Contact
    supportTitle: 'Help & Support',
    supportIntro: 'A question, a bug or a suggestion? Write to us right here, our team replies within 24 to 48 hours.',
    contactSubject: 'Subject',
    contactSubjectPlaceholder: 'E.g. Issue with the simulation',
    contactMessage: 'Message',
    contactMessagePlaceholder: 'Describe your request (10 characters minimum)...',
    contactEmail: 'Your email for the reply',
    contactEmailPlaceholder: 'you@example.com',
    contactSend: 'Send message',
    contactSending: 'Sending...',
    contactSent: 'Message sent! Reference',
    contactError: 'Could not send the message',
    contactTooMany: 'Too many messages sent, try again in an hour.',
    contactOrEmail: 'or by email:',

    // Photo consent
    consentTitle: 'How your photos are used',
    consentIntro: 'Before your first photo analysis, here is how PrimeFace uses your images:',
    consentPoint1: 'Your photo is analysed by an AI (OpenAI) to produce aesthetic recommendations.',
    consentPoint2: 'For simulations, a compressed Before / After version is kept in your history for {days} days, then deleted automatically.',
    consentPoint3: 'You can delete any simulation at any time from your history.',
    consentPoint4: 'Your photos are never shared with third parties nor used for advertising.',
    consentCheckbox: 'I understand and accept the use of my photos under these conditions.',
    consentAccept: 'Continue',
    consentCancel: 'Cancel',
    consentSaved: 'Thank you, your choice has been saved.',
    consentError: 'Could not save your consent',
    consentRequired: 'You must accept the use of your photos to continue.',

    // Compare simulations
    compare: 'Compare',
    compareMode: 'Compare mode',
    compareHint: 'Select two simulations from different dates',
    compareNeedTwo: 'At least two simulations are needed to compare',
    compareSelected: 'selected',
    compareTitle: 'Progress comparison',
    compareSubtitle: 'Your real evolution between two dates',
    compareRealPhotos: 'Real photos',
    compareSimulations: 'AI simulations',
    compareDownload: 'Download comparison',
    compareBack: 'Back to simulations',
    compareLoadError: 'Could not load both simulations',
    compareDaysApart: 'days apart',
    compareNeedTwoTitle: 'Compare your progress over time',
    compareNeedTwoBody: 'Run at least two simulations on different dates: you will then be able to place them side by side to see your real evolution.',
    compareNeedOneMore: 'One more simulation and the comparison will be available.',
    newSimulation: 'New simulation',
    compareShare: 'Share comparison',
    keepLearning: 'Keep learning',
    keepLearningNote: 'PrimeFace guide articles related to this answer',
    readThisWeek: 'Read this week',
    readingReasonMetric: 'Picked from your lowest indicator: {metric} ({value}/100)',
    readingReasonWeekly: 'Pick of the week, until your first metrics are logged',
    allTipsLink: 'All tips',
    compareShareTitle: 'My PrimeFace progress',
    compareShareText: 'Here is my progress between two dates, tracked with PrimeFace.',
    retentionNote: 'Simulations are kept for {days} days and then deleted automatically.',

    // Admin reply
    reply: 'Reply',
    replyPlaceholder: 'Your reply will be emailed to the requester...',
    replySend: 'Send reply',
    replySending: 'Sending...',
    replySent: 'Reply sent by email',
    replyError: 'Could not send the reply',
    replyNoRecipient: 'No email address to reply to this message',
    replyMarkHandled: 'Mark as handled after sending',
    replies: 'Sent replies',
    sentTo: 'sent to',

    // Simulation share
    shareImage: 'Share',
    sharingImage: 'Preparing...',
    shareUnavailable: 'Direct sharing is not available on this device, the image was downloaded instead.',
    shareTitle: 'My PrimeFace Before / After simulation',
    shareText: 'Here is my Before / After simulation generated by PrimeFace.',
    shareError: 'Could not share the image',

    // Simulation history
    simulations: 'Simulations',
    conversations: 'Conversations',
    noSimulations: 'No saved simulation yet',
    savedSimulation: 'Saved simulation',
    openSimulation: 'Open',
    simulationNotFound: 'Simulation not found',
    loadingSimulation: 'Loading the simulation...',
    savedOn: 'Saved on',

    // Jobs / background
    jobTimeout: 'The operation is taking too long, please retry.',
    analysisInProgress: 'Full analysis in progress, this may take a minute...',
    routineInProgress: 'Generating your routine in the background...',

    // Admin inbox
    adminInbox: 'Support inbox',
    adminInboxSubtitle: 'Messages received through the contact form',
    statusNew: 'New',
    statusHandled: 'Handled',
    statusAll: 'All',
    badgeNew: 'New',
    badgeHandled: 'Handled',
    markHandled: 'Mark as handled',
    reopen: 'Reopen',
    replyByEmail: 'Reply by email',
    noContactEmail: 'No contact email',
    noMessages: 'No messages',
    guestUser: 'Guest',
    handledBy: 'Handled by',
    searchMessages: 'Search (subject, email, reference)...',
    adminOnly: 'Administrators only',
    adminNote: 'Internal note',
    adminNotePlaceholder: 'Add an internal note (optional)',
    saveNote: 'Save note',
    downloadImage: 'Download Before / After image',
    downloadingImage: 'Preparing the image...',
    imageDownloaded: 'Image downloaded!',
    imageDownloadError: 'Could not generate the image',
    
    // History
    chatHistory: 'Session History',
    searchSessions: 'Search...',
    deleteSession: 'Delete',
    openSession: 'Open',
    noHistory: 'No history yet',
  }
};

export const t = (key, lang = 'fr') => {
  return translations[lang]?.[key] || translations['en']?.[key] || key;
};

/** Translation with {placeholder} interpolation, e.g. tf('retentionNote', 'fr', { days: 90 }). */
export const tf = (key, lang = 'fr', vars = {}) =>
  Object.entries(vars).reduce((text, [name, value]) => text.replaceAll(`{${name}}`, String(value)), t(key, lang));

export default translations;
